import { PLAKA } from '@/store'

export default {
  computed: {
    showFiltersInHeader () {
      return this.obtainFiltersLiteral(this.filters)
    },
    filters () {
      return this.connectionStarted ? this.$store.getters[PLAKA.GETTERS.GET_FILTERS]() : []
    }
  },
  methods: {
    obtainFiltersLiteral (filterToShow = []) {
      if (typeof this.plkparams.showFiltersInHeader === 'boolean') {
        return this.plkparams.showFiltersInHeader ? filterToShow.map(e => `${this.convertInTitle(e.idElement)}: ${e.values.join(', ')}`).join(', ') : ''
      } else {
        let fun = new Function(['ctx', 'filters'], this.plkparams.showFiltersInHeader)
        return fun.apply(this, [this, filterToShow])
      }
    },
    convertInTitle (idElement = '') {
      let translateValue = this.$t(idElement)
      if (translateValue !== idElement) {
        return translateValue
      } else {
        return idElement.replace(new RegExp('.*\\[(.*)\\].*', 'gi'), '$1')
      }
    },
    clearFilter (element = {}) {
      if (!element.idElement) {
        console.warn(`clearFilter: Not defined idElement`)
        return
      }
      this.getConnection().clearFilter(element)
    },
    isFiltered ({ idElement }) {
      return this.filters.find(f => f.idElement === idElement)
    },
    executeFunction (exec, element) {
      if (exec) {
        try {
          let fun = new Function(['ctx', 'element'], exec)
          return fun.apply(this, [this, element])
        } catch (e) {
          return exec
        }
      }
    }
  }
}
